import { Link as RouterLink, useSearchParams } from "react-router-dom";
import CircularProgress from "@mui/material/CircularProgress";
import Link from "@mui/material/Link";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import { useAuth } from "@bw/shared/hooks";
import { AuthCard } from "../components/AuthCard";
import { AuthForm } from "../components/AuthForm";
import { useAuthRedirect } from "../hooks/useAuthRedirect";

/** Account creation route; profile creation remains in onboarding. */
export function RegisterPage() {
  const { loading } = useAuth();
  const [searchParams] = useSearchParams();

  useAuthRedirect("/");

  const returnUrl = searchParams.get("returnUrl");
  const signInHref = returnUrl
    ? `/login?returnUrl=${encodeURIComponent(returnUrl)}`
    : "/login";

  if (loading) {
    return (
      <Stack
        aria-busy="true"
        role="status"
        spacing={1.5}
        sx={{ alignItems: "center", py: 4 }}
      >
        <CircularProgress size={28} />
        <Typography color="text.secondary">Loading…</Typography>
      </Stack>
    );
  }

  return (
    <AuthCard tagline="Book courts, find a game, and compete.">
      <AuthForm mode="signUp" />

      <Typography
        color="text.secondary"
        variant="body2"
        sx={{ textAlign: "center" }}
      >
        Already have an account?{" "}
        <Link component={RouterLink} to={signInHref}>
          Sign in
        </Link>
      </Typography>
    </AuthCard>
  );
}
